<template>
    <h1 v-if="user">{{ user.attributes.given_name }} {{ user.attributes.family_name }}</h1>
</template>

<script>

import Auth from '@aws-amplify/auth'
import { mapActions } from 'vuex'

export default {
    name: 'User',
    data () {
        return {
            user: null
        }
    },
    methods: {

        ...mapActions({
            spinnerStop: 'spinner/stop'
        })
    },
    mounted () {
        this.spinnerStop()
    },
    created () {
        Auth.currentAuthenticatedUser().then(data => {
            this.user = data
        })
    }
}
</script>

<style scoped>
    h1 {
        color: #23B8DC;
        text-align: center;
    }
</style>
